import classes from './DayScaleEmptyCell.module.css';

const DayScaleEmptyCell = () => {
  return <div className={classes.DayScaleEmptyCell}></div>;
};

export default DayScaleEmptyCell;
